export default {"src":"/_next/static/media/contract-blank-left.cfdc5aa5.svg","height":235,"width":171,"blurWidth":0,"blurHeight":0};